import React from 'react';

export const NextSteps = () => {
  const hasProcessedDepositFundingRequests = true;
  const hasProcessedTransferFundingRequests = false;
  const hasProcessedRolloverFundingRequests = false;

  const downloadDeposits = () => {
    /**something */
  };
  const downloadRollovers = () => {
    /**something */
  };
  const downloadTransfers = () => {
    /**something */
  };

  const onDoneClicked = () => {
    //something
  };
  const onLaterClicked = () => {
    //something
  };
  return (
    <div className="iras-a-fund-account-funding-complete">
      <div className="iras-a-fund-account-funding-complete__container">
        <div className="iras-a-fund-account-funding-complete__module-wrapper">
          <div className="iras-a-fund-account-funding-complete__fieldset-panel--next-steps">
            <div className="iras-a-fund-account-funding-complete__fieldset-panel-header">
              <h3 className="iras-a-fund-account-funding-complete__fieldset-panel-header-title">
                Next Steps
              </h3>
            </div>
            <div className="iras-a-fund-account-funding-complete__fieldset-panel-content">
              <p className="iras-a-fund-account-funding-complete__steps-prompt">
                <b className="iras-a-fund-account-funding-complete__bold">
                  You need to take care of a few last steps to submit each of
                  your transfer requests.
                </b>
              </p>
              <div className="iras-a-fund-account-funding-complete__steps">
                <div className="iras-a-fund-account-funding-complete__fieldset-sub-panel--step">
                  <h4 className="iras-a-fund-account-funding-complete__fieldset-sub-panel-header">
                    <span className="iras-a-fund-account-funding-complete__fieldset-sub-panel-header-label">
                      1. Download and Sign
                    </span>
                  </h4>
                  <div className="iras-a-fund-account-funding-complete__fieldset-sub-panel-content">
                    <p>
                      Click below to download and sign your pre-populated
                      funding request form(s).
                    </p>
                  </div>
                  {hasProcessedDepositFundingRequests && (
                    <div>
                      <button
                        type="button"
                        onClick={downloadDeposits}
                        className="iras-a-fund-account-funding-complete__download-button">
                        Contribution form(s)
                      </button>
                    </div>
                  )}
                  {hasProcessedRolloverFundingRequests && (
                    <div>
                      <button
                        type="button"
                        onClick={downloadRollovers}
                        className="iras-a-fund-account-funding-complete__download-button">
                        Rollover form(s)
                      </button>
                    </div>
                  )}
                  {hasProcessedTransferFundingRequests && (
                    <div>
                      <button
                        type="button"
                        onClick={downloadTransfers}
                        className="iras-a-fund-account-funding-complete__download-button">
                        Transfer form(s)
                      </button>
                    </div>
                  )}
                </div>

                <div className="iras-a-fund-account-funding-complete__fieldset-sub-panel--step">
                  <h4 className="iras-a-fund-account-funding-complete__fieldset-sub-panel-header">
                    <span className="iras-a-fund-account-funding-complete__fieldset-sub-panel-header-label">
                      2. Initiate Request
                    </span>
                  </h4>
                  <div className="iras-a-fund-account-funding-complete__fieldset-sub-panel-content">
                    <p className="iras-a-fund-account-funding-complete__bold">
                      For ACH contributions and Rollovers:
                    </p>
                    Follow the instructions on the form to initiate your request
                    with your bank and/or provider before submitting your
                    completed forms back to Forge Trust.
                    <br />
                    <br />
                    <p className="iras-a-fund-account-funding-complete__bold">
                      For Contributions via Check:
                    </p>
                    Follow the instructions on the form for mailing your check
                    to Forge Trust.
                  </div>
                </div>

                <div className="iras-a-fund-account-funding-complete__fieldset-sub-panel--step">
                  <h4 className="iras-a-fund-account-funding-complete__fieldset-sub-panel-header">
                    <span className="iras-a-fund-account-funding-complete__fieldset-sub-panel-header-label">
                      3. Wait for Confirmation
                    </span>
                  </h4>
                  <div className="iras-a-fund-account-funding-complete__fieldset-sub-panel-content">
                    <p>
                      Once you have completed the previous steps, you can
                      securely upload your signed form by clicking the “Submit
                      Now” button below. If you’re not ready to submit, just
                      follow the instructions on the form to email, fax, or mail
                      your request to Forge Trust.
                    </p>
                    <p>
                      You will be notified via email as soon as your funds are
                      deposited and available for investing.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="iras-a-fund-account-footer">
            <div className="iras-a-fund-account-footer__action-button-wrapper">
              <div className="iras-a-fund-account-footer__action-button-container">
                <button
                  className="iras-a-fund-account-footer__action-button--done"
                  type="button"
                  onClick={onDoneClicked}>
                  Submit Forms Now
                </button>
                <button
                  className="iras-a-fund-account-footer__action-button--done"
                  type="button"
                  onClick={onLaterClicked}>
                  Submit Forms Later
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NextSteps;
